import request from 'react_api/requests';

export default class SitesAPI {
  static getSites({ trial_id, language, country }) {
    const URL = `/api/fetchsitestates/?trial_id=${trial_id}&language=${language}&country=${country}`;
    return request.getCall(URL);
  }
}
